// extracted by mini-css-extract-plugin
export default {"root":"ValueChainMapTable_root__U4Dov","infiniteScroll":"ValueChainMapTable_infiniteScroll__1YhoZ","table":"ValueChainMapTable_table__PxWxV"};